import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {VexPopoverService} from '@vex/components/vex-popover/vex-popover.service';
import {ToolbarUserDropdownComponent} from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import {MatIconModule} from '@angular/material/icon';
import {MatRippleModule} from '@angular/material/core';
import {JsonPipe, NgClass, NgIf} from '@angular/common';
import {StorageService} from '../../../../shared/services/storage.service';
import {AuthService} from '../../../../shared/services/auth.service';
import {DataService} from '../../../../shared/services/data.service';
import {ProfileImageService} from '../../../../shared/services/profile-image.service';
import {CallingDataService} from '../../../../shared/services/calling-data.service';
import {MatDialog, MatDialogContent} from '@angular/material/dialog';
import {TelService} from "../../../../shared/services/tel.service";
import {CallService} from "../../../../shared/services/call.service";
import {ManualLeadService} from "../../../../shared/services/manual-lead.service";
import {FacebookLeadService} from "../../../../shared/services/facebook-lead.service";
import {MessengerLeadService} from "../../../../shared/services/messenger-lead.service";
import {InstagramLeadService} from "../../../../shared/services/instagram-lead.service";

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./toolbar-user.component.scss'],
  standalone: true,
  imports: [
    MatRippleModule,
    MatIconModule,
    JsonPipe,
    NgIf,
    MatDialogContent,
    NgClass
  ],
  providers: [
    StorageService,
    DataService,
    TelService,
    CallService,
    ManualLeadService,
    FacebookLeadService,
    MessengerLeadService,
    InstagramLeadService
  ]
})
export class ToolbarUserComponent implements OnInit {
  @ViewChild('callingModal') callingModal: TemplateRef<any>;
  @ViewChild('receivingModal') receivingModal: TemplateRef<any>;
  dropdownOpen: boolean = false;
  user: any;
  userImageUrl: string;
  hideCallingIcon: any = true;
  hideIncomingCallIcon: any = true;
  callingData: any;
  receivingData: any;
  displayTimer: any = {
    'hours': 0,
    'minutes': 0,
    'seconds': 0,
  };
  displayTimerIncoming: any = {
    'hours': 0,
    'minutes': 0,
    'seconds': 0,
  };
  activity: any = {
    'text': '',
    'color': ''
  };
  subActivity: any = {
    'text': '',
    'color': ''
  };
  activityIncoming: any = {
    'text': '',
    'color': ''
  };
  subActivityIncoming: any = {
    'text': '',
    'color': ''
  };
  callStatus: any;
  callStatusIncoming: any;
  // teleCmiCredentials: any = AppConstants.teleCmiCredentials;
  teleCmiCredentials: any;
  timerId: any;
  timerIdIncoming: any;
  isCallActive: boolean = true;
  actionKeys: any = {
    'hold': 'SHOW_AND_ACTIVE',
    'unhold': 'SHOW_AND_ACTIVE',
    'mute': 'SHOW_AND_ACTIVE',
    'unmute': 'SHOW_AND_ACTIVE',
    'call': 'SHOW_AND_ACTIVE'
  };
  actionKeysIncoming: any = {
    'receive': 'SHOW_AND_ACTIVE',
    'hold': 'SHOW_AND_ACTIVE',
    'unhold': 'SHOW_AND_ACTIVE',
    'mute': 'SHOW_AND_ACTIVE',
    'unmute': 'SHOW_AND_ACTIVE',
    'call': 'SHOW_AND_ACTIVE'
  };
  private incomingAudio: HTMLAudioElement;
  private outgoingAudio: HTMLAudioElement;

  constructor(private popover: VexPopoverService,
              private cd: ChangeDetectorRef,
              private authService: AuthService,
              private imageService: ProfileImageService,
              private callingDataService: CallingDataService,
              protected dialog: MatDialog,
              private telService: TelService,
              private callService: CallService,
              private manualLeadService: ManualLeadService,
              private facebookLeadService: FacebookLeadService,
              private messengerLeadService: MessengerLeadService,
              private instagramLeadService: InstagramLeadService) {
    this.incomingAudio = new Audio('assets/audios/incoming-tone.mp3');
    this.outgoingAudio = new Audio('assets/audios/outgoing-tone.mp3');
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
        if (this.user['telecom_user_id']) {
          this.teleCmiCredentials = {
            'user_id': this.user['telecom_user_id'],
            'password': this.user['telecom_password'],
            'region': this.user['telecom_region']
          };
          this.loginAgent();
        }
        this.userImageUrl = this.user.profile_image;
        this.cd.detectChanges();
      }
    });

    this.imageService.getData().subscribe(data => {
      this.userImageUrl = data;
      this.cd.detectChanges();
    });

    this.callingDataService.getData().subscribe(data => {
      this.receivingData = undefined;
      this.callingData = data;
      this.callingData['name_first_character'] = (data && data['name']) ? (data['name'].substring(0, 1)).toLowerCase() : '-';
      this.hideCallingIcon = false;
      this.openCallingModal();
      this.cd.detectChanges();
    });

    this.callingDataService.getIncomingCallData().subscribe(data => {
      if (data && data['from']) {
        this.callingData = undefined;
        this.receivingData = data;
        this.activityIncoming['text'] = 'Incoming Call...';
        this.activityIncoming['color_class'] = 'color-success';
        this.actionKeysIncoming = {
          'receive': 'SHOW_AND_ACTIVE',
          'hold': 'HIDE',
          'unhold': 'HIDE',
          'mute': 'HIDE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.hideIncomingCallIcon = false;
        this.cd.detectChanges();
        this.checkCallHangUp();
        this.playIncomingRingtone();

        this.getExistedUserData();

        const params: {} = {
          'lead_id': (this.receivingData && this.receivingData['id']) ? this.receivingData['id'] : '',
          'sources': (this.receivingData && this.receivingData['lead_source']) ? this.receivingData['lead_source'] : '',
          'contact': (this.receivingData && this.receivingData['contact']) ? this.receivingData['contact'] : '',
          'types': (this.receivingData && this.receivingData['types']) ? this.receivingData['types'] : '',
          'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          'call_current_status': 'TRYING'
        };
        this.callService.add(params).subscribe(data => {
          if (data && data['id']) {
            this.receivingData['entry_id'] = data['id'];
            this.receivingData['entry_unique_id'] = data['unique_id'];
          }
        });
      }
    });

    this.callingDataService.getActivityData().subscribe(data => {
      if (data && data['code'] === 100 && data['activity'] === 'TRYING') {
        if (this.callingData && this.callingData['id']) {
          const params: {} = {
            'lead_id': (this.callingData && this.callingData['id']) ? this.callingData['id'] : '',
            'sources': (this.callingData && this.callingData['lead_source']) ? this.callingData['lead_source'] : '',
            'contact': (this.callingData && this.callingData['contact']) ? this.callingData['contact'] : '',
            'types': (this.callingData && this.callingData['types']) ? this.callingData['types'] : '',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming,
            'call_current_status': 'TRYING'
          };
          this.callService.add(params).subscribe(data => {
            if (data && data['id']) {
              this.callingData['entry_id'] = data['id'];
              this.callingData['entry_unique_id'] = data['unique_id'];
            }
          });
        } else if (this.receivingData && this.receivingData['id']) {
          this.getExistedUserData();
        }
      } else if (data && data['code'] === 183 && data['activity'] === 'RINGING') {
        this.activity = {
          'text': 'Ringing...',
          'color_class': 'color-success'
        };
        if (data['type'] === 'outgoing') {
          const params: any = {
            'call_current_status': 'RINGING',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming,
          };
          if (this.callingData && (!this.callingData['current_call_status'] || this.callingData['current_call_status'] !== 'RINGING')) {
            this.callingData['current_status_update'] = 'RINGING';
            this.callService.updateCallCurrentStatus(params, this.callingData['entry_unique_id']).subscribe(data => {

            });
          }
          this.playOutgoingRingtone();
        } else if (data['type'] === 'incoming') {
          const params: any = {
            'call_current_status': 'RINGING',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          };
          if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'RINGING')) {
            this.receivingData['current_status_update'] = 'RINGING';
            this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

            });
          }
        }
        this.subActivity = undefined;
        this.actionKeys = {
          'hold': 'SHOW_AND_INACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_INACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.displayTimer = {
          'hours': 0,
          'minutes': 0,
          'seconds': 0,
        };
      } else if (data && (data['code'] === 480 || data['code'] === 408) && data['activity'] === 'ENDED') {
        this.activity = {
          'text': 'No Answer',
          'color_class': 'text-danger'
        };
        this.actionKeys = {
          'hold': 'SHOW_AND_INACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_INACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.subActivity = undefined;
        this.stopOutgoingRingtone();
        setTimeout(() => {
          this.hideCallingIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);
        if (this.callingData && this.callingData['id']) {
          const params: any = {
            'call_current_status': 'NO_ANSWER',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming
          };
          if (this.callingData && (!this.callingData['current_status_update'] || this.callingData['current_status_update'] !== 'NO_ANSWER')) {
            this.callingData['current_status_update'] = 'NO_ANSWER';
            this.callService.updateCallCurrentStatus(params, this.callingData['entry_unique_id']).subscribe(data => {

            });
          }
        } else if (this.receivingData && this.receivingData['id']) {
          const params: any = {
            'call_current_status': 'NO_ANSWER',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer
          };
          if (this.receivingData && (!this.receivingData['current_status_update'] && this.receivingData['current_status_update'] !== 'NO_ANSWER')) {
            this.receivingData['current_status_update'] = 'NO_ANSWER';
            this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

            });
          }
        }
      } else if (data && data['code'] === 484 && data['activity'] === 'ENDED') {
        this.activity = {
          'text': 'Wrong Number',
          'color_class': 'text-danger'
        };
        this.actionKeys = {
          'hold': 'SHOW_AND_INACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_INACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.subActivity = undefined;
        this.stopOutgoingRingtone();
        setTimeout(() => {
          this.hideCallingIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);

        if (this.callingData && this.callingData['id']) {
          const params: any = {
            'call_current_status': 'WRONG_NUMBER',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming
          };
          if (this.callingData && (!this.callingData['current_status_update'] || this.callingData['current_status_update'] !== 'WRONG_NUMBER')) {
            this.callingData['current_status_update'] = 'WRONG_NUMBER';
            this.callService.updateCallCurrentStatus(params, this.callingData['entry_unique_id']).subscribe(data => {

            });
          }
        } else if (this.receivingData && this.receivingData['id']) {
          const params: any = {
            'call_current_status': 'WRONG_NUMBER',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer
          };
          if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'WRONG_NUMBER')) {
            this.receivingData['current_status_update'] = 'WRONG_NUMBER';
            this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

            });
          }
        }
      } else if (data && data['code'] === 486 && data['activity'] === 'ENDED') {
        this.activity = {
          'text': 'User Busy',
          'color_class': 'text-danger'
        };
        this.actionKeys = {
          'hold': 'SHOW_AND_INACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_INACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.subActivity = undefined;
        this.stopOutgoingRingtone();
        setTimeout(() => {
          this.hideCallingIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);

        if (this.callingData && this.callingData['id']) {
          const params: any = {
            'call_current_status': 'USER_BUSY',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming
          };
          if (this.callingData && (!this.callingData['current_status_update'] || this.callingData['current_status_update'] !== 'USER_BUSY')) {
            this.callingData['current_status_update'] = 'USER_BUSY';
            this.callService.updateCallCurrentStatus(params, this.callingData['entry_unique_id']).subscribe(data => {

            });
          }
        } else if (this.receivingData && this.receivingData['id']) {
          const params: any = {
            'call_current_status': 'USER_BUSY',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer
          };
          if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'USER_BUSY')) {
            this.receivingData['current_status_update'] = 'USER_BUSY';
            this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

            });
          }
        }
      } else if (data && data['code'] === 200 && data['activity'] === 'ANSWERED') {
        this.stopOutgoingRingtone();
        this.stopIncomingRingtone();
        this.activity = {
          'text': 'Call Answered',
          'color_class': 'color-success'
        };
        this.callStatus = 'STARTED';
        this.actionKeys = {
          'hold': 'SHOW_AND_ACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_ACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.subActivity = undefined;
        this.startIncreasingTimer();

        this.activityIncoming = {
          'text': 'Call Answered',
          'color_class': 'color-success'
        };
        this.actionKeysIncoming = {
          'hold': 'SHOW_AND_ACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_ACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };

        if (this.callingData && this.callingData['id']) {
          const params: any = {
            'call_current_status': 'ANSWERED',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming
          };
          if (this.callingData && (!this.callingData['current_status_update'] || this.callingData['current_status_update'] !== 'ANSWERED')) {
            this.callingData['current_status_update'] = 'ANSWERED';
            this.callService.updateCallCurrentStatus(params, this.callingData['entry_unique_id']).subscribe(data => {

            });
          }
        } else if (this.receivingData && this.receivingData['id']) {
          const params: any = {
            'call_current_status': 'ANSWERED',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer
          };
          if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'ANSWERED')) {
            this.receivingData['current_status_update'] = 'ANSWERED';
            this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

            });
          }
        }
      } else if (data && data['code'] === 200 && data['activity'] === 'HANG_UP') {
        this.activity = {
          'text': 'Call Hang Up',
          'color_class': 'text-danger'
        };
        this.actionKeys = {
          'hold': 'SHOW_AND_INACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_INACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.callStatus = 'ENDED';
        this.subActivity = undefined;
        this.stopOutgoingRingtone();
        this.stopIncomingRingtone();
        this.stopTimer('END_CALL');

        this.activityIncoming = {
          'text': 'Call Hang Up',
          'color_class': 'text-danger'
        };
        this.actionKeysIncoming = {
          'hold': 'SHOW_AND_INACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_INACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_INACTIVE'
        };
        this.subActivityIncoming = undefined;
        setTimeout(() => {
          this.hideIncomingCallIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);

        if (this.callingData && this.callingData['id']) {
          const params: any = {
            'call_current_status': 'HANG_UP',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming
          };
          if (this.callingData && (!this.callingData['current_status_update'] || this.callingData['current_status_update'] !== 'HANG_UP')) {
            this.callingData['current_status_update'] = 'HANG_UP';
            this.callService.updateCallCurrentStatus(params, this.callingData['entry_unique_id']).subscribe(data => {

            });
          }
        } else if (this.receivingData && this.receivingData['id']) {
          const params: any = {
            'call_current_status': 'HANG_UP',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer
          };
          if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'HANG_UP')) {
            this.receivingData['current_status_update'] = 'HANG_UP';
            this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

            });
          }
        }
      } else if (data && data['code'] === 200 && data['activity'] === 'ENDED') {
        this.activity = {
          'text': 'Call Ended',
          'color_class': 'text-danger'
        };
        this.actionKeys = {
          'hold': 'SHOW_AND_INACTIVE',
          'unhold': 'HIDE',
          'mute': 'SHOW_AND_INACTIVE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.callStatus = 'ENDED';
        this.subActivity = undefined;
        this.stopOutgoingRingtone();
        this.stopIncomingRingtone();
        this.stopTimer('END_CALL');

        this.activityIncoming = {
          'text': 'Call Ended',
          'color_class': 'text-danger'
        };
        this.actionKeysIncoming = {
          'hold': 'HIDE',
          'unhold': 'HIDE',
          'mute': 'HIDE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_INACTIVE',
          'receive': 'SHOW_AND_INACTIVE'
        };
        this.subActivityIncoming = undefined;
        setTimeout(() => {
          this.hideIncomingCallIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);

        if (this.callingData && this.callingData['id']) {
          const params: any = {
            'call_current_status': 'ENDED',
            'duration': (this.callingData) ? this.displayTimer : this.displayTimerIncoming
          };
          if (this.callingData && (!this.callingData['current_status_update'] || this.callingData['current_status_update'] !== 'ENDED')) {
            this.callingData['current_status_update'] = 'ENDED';
            this.callService.updateCallCurrentStatus(params, this.callingData['entry_unique_id']).subscribe(data => {

            });
          }
        } else if (this.receivingData && this.receivingData['id']) {
          const params: any = {
            'call_current_status': 'ENDED',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer
          };
          if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'ENDED')) {
            this.receivingData['current_status_update'] = 'ENDED';
            this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

            });
          }
        }
      }
    });
  }

  ngOnInit() {
  }

  loginAgent() {
    if (this.teleCmiCredentials && this.teleCmiCredentials['user_id']) {
      this.telService.sdk.login(this.teleCmiCredentials.user_id, this.teleCmiCredentials.password, this.teleCmiCredentials.region);
      this.telService.handleLoginProcess().subscribe(response => {
        this.checkIncomingCall();
      }, error => {
        console.log('error', error);
      });
    }
  }

  checkIncomingCall() {
    this.telService.handleInComingCall().subscribe(response => {
      if (response && response['from']) {
        this.receivingData = response;
        this.activityIncoming['text'] = 'Incoming Call...';
        this.activityIncoming['color_class'] = 'color-success';
        this.actionKeysIncoming = {
          'receive': 'SHOW_AND_ACTIVE',
          'hold': 'HIDE',
          'unhold': 'HIDE',
          'mute': 'HIDE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_ACTIVE'
        };
        this.hideIncomingCallIcon = false;
        this.cd.detectChanges();
        this.checkCallHangUp();
        this.playIncomingRingtone();
        this.getExistedUserData();
      }
    }, error => {
      console.log('error', error);
    });
  }

  getExistedUserData() {
    let contactNo = this.receivingData['from'].substring(2);
    this.checkManualLead(contactNo);
  }

  checkManualLead(contactNo) {
    this.manualLeadService.get({'contact': contactNo}).subscribe(response => {
      if (response && response['data'] && response['data'].length > 0) {
        this.receivingData = response['data'][0];
        this.receivingData['name_first_character'] = (response['data'][0] && response['data'][0]['name']) ? (response['data'][0]['name'].substring(0, 1)).toLowerCase() : '-';
        this.receivingData['lead_source'] = 'MANUAL';
        this.receivingData['types'] = 'INCOMING';

        const params: {} = {
          'lead_id': (this.receivingData && this.receivingData['id']) ? this.receivingData['id'] : '',
          'sources': (this.receivingData && this.receivingData['lead_source']) ? this.receivingData['lead_source'] : '',
          'contact': (this.receivingData && this.receivingData['contact']) ? this.receivingData['contact'] : '',
          'types': (this.receivingData && this.receivingData['types']) ? this.receivingData['types'] : '',
          'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          'call_current_status': 'RINGING'
        };
        this.callService.add(params).subscribe(data => {
          if (data && data['id']) {
            this.receivingData['entry_id'] = data['id'];
            this.receivingData['entry_unique_id'] = data['unique_id'];
          }
        });
      }
    }, error => {
      this.checkFacebookLead(contactNo);
    });
  }

  checkFacebookLead(contactNo) {
    this.facebookLeadService.get({'contact': contactNo}).subscribe(response => {
      if (response && response['data'] && response['data'].length > 0) {
        this.receivingData = response['data'][0];
        this.receivingData['name_first_character'] = (response['data'][0] && response['data'][0]['name']) ? (response['data'][0]['name'].substring(0, 1)).toLowerCase() : '-';
        this.receivingData['lead_source'] = 'FACEBOOK';
        this.receivingData['types'] = 'INCOMING';

        const params: {} = {
          'lead_id': (this.receivingData && this.receivingData['id']) ? this.receivingData['id'] : '',
          'sources': (this.receivingData && this.receivingData['lead_source']) ? this.receivingData['lead_source'] : '',
          'contact': (this.receivingData && this.receivingData['contact']) ? this.receivingData['contact'] : '',
          'types': (this.receivingData && this.receivingData['types']) ? this.receivingData['types'] : '',
          'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          'call_current_status': 'RINGING'
        };
        this.callService.add(params).subscribe(data => {
          if (data && data['id']) {
            this.receivingData['entry_id'] = data['id'];
            this.receivingData['entry_unique_id'] = data['unique_id'];
          }
        });
      }
    }, error => {
      this.checkMessengerLead(contactNo);
    });
  }

  checkMessengerLead(contactNo) {
    this.messengerLeadService.get({'contact': contactNo}).subscribe(response => {
      if (response && response['data'] && response['data'].length > 0) {
        this.receivingData = response['data'][0];
        this.receivingData['name_first_character'] = (response['data'][0] && response['data'][0]['name']) ? (response['data'][0]['name'].substring(0, 1)).toLowerCase() : '-';
        this.receivingData['lead_source'] = 'MESSENGER';
        this.receivingData['types'] = 'INCOMING';

        const params: {} = {
          'lead_id': (this.receivingData && this.receivingData['id']) ? this.receivingData['id'] : '',
          'sources': (this.receivingData && this.receivingData['lead_source']) ? this.receivingData['lead_source'] : '',
          'contact': (this.receivingData && this.receivingData['contact']) ? this.receivingData['contact'] : '',
          'types': (this.receivingData && this.receivingData['types']) ? this.receivingData['types'] : '',
          'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          'call_current_status': 'RINGING'
        };
        this.callService.add(params).subscribe(data => {
          if (data && data['id']) {
            this.receivingData['entry_id'] = data['id'];
            this.receivingData['entry_unique_id'] = data['unique_id'];
          }
        });
      }
    }, error => {
      this.checkInstagramLead(contactNo);
    });
  }

  checkInstagramLead(contactNo) {
    this.instagramLeadService.get({'contact': contactNo}).subscribe(response => {
      if (response && response['data'] && response['data'].length > 0) {
        this.receivingData = response['data'][0];
        this.receivingData['name_first_character'] = (response['data'][0] && response['data'][0]['name']) ? (response['data'][0]['name'].substring(0, 1)).toLowerCase() : '-';
        this.receivingData['lead_source'] = 'INSTAGRAM';
        this.receivingData['types'] = 'INCOMING';

        const params: {} = {
          'lead_id': (this.receivingData && this.receivingData['id']) ? this.receivingData['id'] : '',
          'sources': (this.receivingData && this.receivingData['lead_source']) ? this.receivingData['lead_source'] : '',
          'contact': (this.receivingData && this.receivingData['contact']) ? this.receivingData['contact'] : '',
          'types': (this.receivingData && this.receivingData['types']) ? this.receivingData['types'] : '',
          'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          'call_current_status': 'RINGING'
        };
        this.callService.add(params).subscribe(data => {
          if (data && data['id']) {
            this.receivingData['entry_id'] = data['id'];
            this.receivingData['entry_unique_id'] = data['unique_id'];
          }
        });
      }
    }, error => {
      this.receivingData = {
        'contact': contactNo
      };
      this.receivingData['lead_source'] = 'UNKNOWN';
      this.receivingData['types'] = 'INCOMING';

      const params: {} = {
        'sources': (this.receivingData && this.receivingData['lead_source']) ? this.receivingData['lead_source'] : '',
        'contact': (this.receivingData && this.receivingData['contact']) ? this.receivingData['contact'] : '',
        'types': (this.receivingData && this.receivingData['types']) ? this.receivingData['types'] : '',
        'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
        'call_current_status': 'RINGING'
      };
      this.callService.add(params).subscribe(data => {
        if (data && data['id']) {
          this.receivingData['entry_id'] = data['id'];
          this.receivingData['entry_unique_id'] = data['unique_id'];
        }
      });
    });
  }

  checkCallHangUp() {
    this.telService.handleCallHangupProcess().subscribe(response => {
      if (response && response['code'] === 200) {
        this.stopIncomingRingtone();
        this.activityIncoming['text'] = 'Call Disconnected';
        this.activityIncoming['color_class'] = 'text-danger';
        this.actionKeysIncoming = {
          'receive': 'SHOW_AND_INACTIVE',
          'hold': 'HIDE',
          'unhold': 'HIDE',
          'mute': 'HIDE',
          'unmute': 'HIDE',
          'call': 'SHOW_AND_INACTIVE'
        };
        setTimeout(() => {
          this.displayTimerIncoming = {
            'hours': 0,
            'minutes': 0,
            'seconds': 0
          };
          this.hideIncomingCallIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);

        let params: any = {};
        if (response['status'] === 'call ended') {
          params = {
            'call_current_status': 'DISCONNECTED',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          };
        } else if (response['status'] === 'call hangup') {
          params = {
            'call_current_status': 'HANG_UP',
            'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer,
          };
        }
        if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'HANG_UP')) {
          this.receivingData['current_status_update'] = 'HANG_UP';
          this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

          });
        }
      }
    }, error => {
      console.log('error', error);
    });
  }

  playIncomingRingtone() {
    this.incomingAudio.loop = true;
    this.incomingAudio.play().catch(error => {
      console.error('Error playing audio:', error);
    });
  }

  stopIncomingRingtone() {
    this.incomingAudio.pause();
    this.incomingAudio.currentTime = 0;
  }

  playOutgoingRingtone() {
    this.outgoingAudio.loop = true;
    this.outgoingAudio.play().catch(error => {
      console.error('Error playing audio:', error);
    });
  }

  stopOutgoingRingtone() {
    this.outgoingAudio.pause();
    this.outgoingAudio.currentTime = 0;
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
    this.getSelf();
  }

  getSelf() {
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
        this.cd.detectChanges();
      }
    });
  }

  openCallingModal(): void {
    this.dialog.open(this.callingModal, {
      width: '30vw',
      minWidth: '350px'
    });
  }

  openReceivingModal(): void {
    this.dialog.open(this.receivingModal, {
      width: '30vw',
      minWidth: '350px'
    });
  }

  hangupCall() {
    this.telService.sdk.terminate();
    this.stopIncomingRingtone();
    this.stopOutgoingRingtone();
    this.hideCallingIcon = true;
    this.cd.detectChanges();
    this.closeModal();
    this.telService.handleError().subscribe(response => {

    });
  }

  holdCall() {
    this.telService.sdk.hold();
    this.actionKeys = {
      'hold': 'HIDE',
      'unhold': 'SHOW_AND_ACTIVE',
      'mute': 'SHOW_AND_INACTIVE',
      'unmute': 'HIDE',
      'call': this.actionKeys['call']
    };
    this.subActivity = {
      'text': 'Call On Hold',
      'color_class': 'text-danger'
    };
    this.telService.handleHoldProcess().subscribe(response => {

    });
    this.telService.handleError().subscribe(response => {

    });
  }

  unHoldCall() {
    this.telService.sdk.unHold();
    this.actionKeys = {
      'hold': 'SHOW_AND_ACTIVE',
      'unhold': 'HIDE',
      'mute': 'SHOW_AND_ACTIVE',
      'unmute': 'HIDE',
      'call': this.actionKeys['call']
    };
    this.subActivity = undefined;
    this.telService.handleHoldProcess().subscribe(response => {

    });
    this.telService.handleError().subscribe(response => {

    });
  }

  muteCall() {
    this.telService.sdk.mute();
    this.actionKeys = {
      'hold': 'SHOW_AND_INACTIVE',
      'unhold': 'HIDE',
      'mute': 'HIDE',
      'unmute': 'SHOW_AND_ACTIVE',
      'call': this.actionKeys['call']
    };
    this.subActivity = {
      'text': 'Call On Mute',
      'color_class': 'text-danger'
    };
    this.telService.handleError().subscribe(response => {

    });
  }

  unMuteCall() {
    this.telService.sdk.unMute();
    this.actionKeys = {
      'hold': 'SHOW_AND_ACTIVE',
      'unhold': 'HIDE',
      'mute': 'SHOW_AND_ACTIVE',
      'unmute': 'HIDE',
      'call': this.actionKeys['call']
    };
    this.subActivity = undefined;
    this.telService.handleError().subscribe(response => {

    });
  }

  answerCall(): void {
    this.telService.sdk.answer();
    this.activityIncoming['text'] = 'On Call';
    this.activityIncoming['color_class'] = 'color-success';
    this.actionKeysIncoming = {
      'receive': 'HIDE',
      'hold': 'SHOW_AND_ACTIVE',
      'unhold': 'HIDE',
      'mute': 'SHOW_AND_ACTIVE',
      'unmute': 'HIDE',
      'call': 'SHOW_AND_ACTIVE'
    };
    this.stopIncomingRingtone();
    this.startIncreasingIncomingTimer();

    const params: any = {
      'call_current_status': 'ANSWERED',
      'duration': (this.receivingData) ? this.displayTimerIncoming : this.displayTimer
    };
    if (this.receivingData && (!this.receivingData['current_status_update'] || this.receivingData['current_status_update'] !== 'ANSWERED')) {
      this.receivingData['current_status_update'] = 'ANSWERED';
      this.callService.updateCallCurrentStatus(params, this.receivingData['entry_unique_id']).subscribe(data => {

      });
    }
  }

  hangupCallIncoming() {
    this.telService.sdk.terminate();
    this.hideIncomingCallIcon = true;
    this.cd.detectChanges();
    this.closeModal();
    this.telService.handleError().subscribe(response => {

    });
  }

  holdCallIncoming() {
    this.telService.sdk.hold();
    this.actionKeysIncoming = {
      'receive': 'HIDE',
      'hold': 'HIDE',
      'unhold': 'SHOW_AND_ACTIVE',
      'mute': 'SHOW_AND_INACTIVE',
      'unmute': 'HIDE',
      'call': this.actionKeysIncoming['call']
    };
    this.subActivityIncoming = {
      'text': 'Call On Hold',
      'color_class': 'text-danger'
    };
    this.telService.handleHoldProcess().subscribe(response => {

    });
    this.telService.handleError().subscribe(response => {

    });
  }

  unHoldCallIncoming() {
    this.telService.sdk.unHold();
    this.actionKeysIncoming = {
      'receive': 'HIDE',
      'hold': 'SHOW_AND_ACTIVE',
      'unhold': 'HIDE',
      'mute': 'SHOW_AND_ACTIVE',
      'unmute': 'HIDE',
      'call': this.actionKeysIncoming['call']
    };
    this.subActivityIncoming = undefined;
    this.telService.handleHoldProcess().subscribe(response => {

    });
    this.telService.handleError().subscribe(response => {

    });
  }

  muteCallIncoming() {
    this.telService.sdk.mute();
    this.actionKeysIncoming = {
      'receive': 'HIDE',
      'hold': 'SHOW_AND_INACTIVE',
      'unhold': 'HIDE',
      'mute': 'HIDE',
      'unmute': 'SHOW_AND_ACTIVE',
      'call': this.actionKeysIncoming['call']
    };
    this.subActivityIncoming = {
      'text': 'Call On Mute',
      'color_class': 'text-danger'
    };
    this.telService.handleError().subscribe(response => {

    });
  }

  unMuteCallIncoming() {
    this.telService.sdk.unMute();
    this.actionKeysIncoming = {
      'receive': 'HIDE',
      'hold': 'SHOW_AND_ACTIVE',
      'unhold': 'HIDE',
      'mute': 'SHOW_AND_ACTIVE',
      'unmute': 'HIDE',
      'call': this.actionKeysIncoming['call']
    };
    this.subActivityIncoming = undefined;
    this.telService.handleError().subscribe(response => {

    });
  }

  startIncreasingTimer() {
    if (this.timerId) {
      this.stopTimer();
    }

    let seconds: any = 0;
    let minutes: any = 0;
    let hours: any = 0;

    if (this.callStatus === 'STARTED') {
      seconds = 0;
      minutes = 0;
      hours = 0;
    }

    this.timerId = setInterval(() => {
      seconds++;
      if (seconds === 60) {
        seconds = 0;
        minutes++;
      }
      if (minutes === 60) {
        minutes = 0;
        hours++;
      }

      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      seconds = String(seconds).padStart(2, '0');

      this.displayTimer = {
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      };
    }, 1000);
  }

  stopTimer(status?) {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;

      if (status === 'END_CALL') {
        setTimeout(() => {
          this.displayTimer = {
            'hours': 0,
            'minutes': 0,
            'seconds': 0
          };
          this.hideCallingIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);
      }
    }
  }

  startIncreasingIncomingTimer() {
    if (this.timerIdIncoming) {
      this.stopTimerIncoming();
    }

    let seconds: any = 0;
    let minutes: any = 0;
    let hours: any = 0;

    if (this.callStatusIncoming === 'STARTED') {
      seconds = 0;
      minutes = 0;
      hours = 0;
    }

    this.timerIdIncoming = setInterval(() => {
      seconds++;
      if (seconds === 60) {
        seconds = 0;
        minutes++;
      }
      if (minutes === 60) {
        minutes = 0;
        hours++;
      }

      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      seconds = String(seconds).padStart(2, '0');

      this.displayTimerIncoming = {
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      };
      this.checkIncomingCallStream();
    }, 1000);
  }

  checkIncomingCallStream() {
    if (!this.telService.sdk.getCallId()) {
      this.stopTimerIncoming('END_CALL');
    }
  }

  stopTimerIncoming(status?) {
    if (this.timerIdIncoming) {
      clearInterval(this.timerIdIncoming);
      this.timerIdIncoming = null;

      if (status === 'END_CALL') {
        setTimeout(() => {
          this.displayTimerIncoming = {
            'hours': 0,
            'minutes': 0,
            'seconds': 0
          };
          this.hideIncomingCallIcon = true;
          this.cd.detectChanges();
          this.closeModal();
        }, 5000);
      }
    }
  }

  closeModal(): void {
    this.dialog.closeAll();
  }
}
